import { Trans } from "@lingui/react/macro"
import React from "react"

import * as analytics from "../../../../utils/analytics"
import { CLIENT_TOUR_URL } from "../../../../utils/urls"
import {
  Api,
  Integrations,
  ProductOverview,
  Recipient,
  Security,
  Send,
  Warning,
} from "../../../icon/icon-static-map"
import DropdownHighlight from "../dropdown-highlight"
import DropdownMain from "../dropdown-main"
import NavList from "../nav-list"
import NavListItem from "../nav-list-item"

const ProductDropdown = () => {
  return (
    <>
      <DropdownMain>
        <NavList title={<Trans>platform</Trans>}>
          <NavListItem
            href="/products/overview"
            icon={<ProductOverview color="orange" size="small" />}
            label={<Trans>Product overview</Trans>}
            text={<Trans>Learn more about how the platform works</Trans>}
          />
          <NavListItem
            href="/gift-card-api"
            icon={<Api color="blue" size="small" />}
            label={<Trans>API</Trans>}
            text={<Trans>Automate your payouts</Trans>}
          />
          <NavListItem
            href="/products/security"
            icon={<Security color="magenta" size="small" />}
            label={<Trans>Security</Trans>}
            text={<Trans>Protect your data and money</Trans>}
          />
        </NavList>
        <NavList title={<Trans>capabilities</Trans>}>
          <NavListItem
            href="/products/fraud-prevention"
            icon={<Warning color="gold" size="small" />}
            label={<Trans>Fraud prevention</Trans>}
            text={<Trans>Stop fraud with AI and customizable controls</Trans>}
          />
          <NavListItem
            href="/integrations"
            icon={<Integrations color="gold" size="small" />}
            label={<Trans>Integrations</Trans>}
            text={
              <Trans>Automate payouts from leading tools and platforms</Trans>
            }
          />
        </NavList>
        <NavList title={<Trans>see it in action</Trans>}>
          <NavListItem
            href={CLIENT_TOUR_URL}
            icon={<Send color="blue" size="small" />}
            label={<Trans>Sending tour</Trans>}
            text={<Trans>See how quick and easy it is to send payouts</Trans>}
            onClick={() => {
              analytics.track(analytics.eventNames.clientTourRequested)
            }}
          />
          <NavListItem
            href="/recipient-tour"
            icon={<Recipient color="gold" size="small" />}
            label={<Trans>Receiving tour</Trans>}
            text={<Trans>Experience what it's like to receive payouts</Trans>}
          />
        </NavList>
      </DropdownMain>
      <DropdownHighlight category="product" />
    </>
  )
}

export default ProductDropdown
